"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectSkypeNotificationOption_1 = require("../data/mutators/selectSkypeNotificationOption");
var SkypeNotificationType_1 = require("../data/store/schema/SkypeNotificationType");
var store_1 = require("../data/store/store");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_options_core_1 = require("owa-options-core");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
var SkypeNotificationFull = /** @class */ (function (_super) {
    tslib_1.__extends(SkypeNotificationFull, _super);
    function SkypeNotificationFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (option, isImNotification) {
            selectSkypeNotificationOption_1.default(_this.getNotificationType(option.key), isImNotification);
        };
        return _this;
    }
    SkypeNotificationFull.prototype.render = function () {
        var _this = this;
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var imNotificationType = owa_options_core_1.getFallbackValueIfNull(optionStore.imNotification, userOptions.skypeMessageNotification).toString();
        var callNotificationType = owa_options_core_1.getFallbackValueIfNull(optionStore.callNotification, userOptions.skypeCallingNotification).toString();
        var choices = [
            {
                key: SkypeNotificationType_1.default.ToastAndSound.toString(),
                text: owa_options_strings_1.default.options_skype_NotifyAll,
            },
            {
                key: SkypeNotificationType_1.default.ToastOnly.toString(),
                text: owa_options_strings_1.default.options_skype_NotifyToast,
            },
            {
                key: SkypeNotificationType_1.default.None.toString(),
                text: owa_options_strings_1.default.options_skype_ImNotifyNone,
            },
        ];
        return (React.createElement("div", null,
            React.createElement(ChoiceGroup_1.ChoiceGroup, { label: owa_options_strings_1.default.options_skype_ImNotifityTitle, selectedKey: imNotificationType, options: choices, onChange: function (ev, option) {
                    return _this.onChange(option, true /* isImNotification*/);
                } }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { label: owa_options_strings_1.default.options_skype_CallNotifityTitle, selectedKey: callNotificationType, options: choices, onChange: function (ev, option) {
                    return _this.onChange(option, false /* isImNotification*/);
                } })));
    };
    SkypeNotificationFull.prototype.getNotificationType = function (num) {
        switch (num) {
            case '1':
                return SkypeNotificationType_1.default.ToastAndSound;
            case '2':
                return SkypeNotificationType_1.default.ToastOnly;
            default:
                return SkypeNotificationType_1.default.None;
        }
    };
    SkypeNotificationFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default(); },
            userOptions: function () {
                return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications);
            },
        })
    ], SkypeNotificationFull);
    return SkypeNotificationFull;
}(React.Component));
exports.default = SkypeNotificationFull;
//# sourceMappingURL=SkypeNotificationFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/view/SkypeNotificationFull.js
// module id = 3376
// module chunks = 2 39